import type { Attempt } from "../Questions/types"
import type { PaperSession } from "../PracticePapers/types"

export type AssessorFilterTab = "all" | "questions" | "papers"
export type AssessorSortOrder = "newest" | "best" | "worst"

export interface QuestionAssessmentMeta {
  questionId: string
  subjectTitle: string
  year: number | null
  topicPath: string
  snippet: string
}

export interface QuestionAssessmentRecord {
  kind: "question"
  id: string
  questionId: string
  subjectTitle: string
  year: number | null
  topicPath: string
  snippet: string
  attempt: Attempt
  date: string
}

export interface PaperAssessmentRecord {
  kind: "paper"
  id: string
  session: PaperSession
  date: string
}

export type AssessmentRecord = QuestionAssessmentRecord | PaperAssessmentRecord

export interface AssessmentCounts {
  total: number
  questions: number
  papers: number
}

export interface AssessmentFeed {
  records: AssessmentRecord[]
  subjects: string[]
  topics: string[]
  summary: AssessmentCounts
  filtered: AssessmentCounts
}

export const ASSESSOR_SORT_LABELS: Record<AssessorSortOrder, string> = {
  newest: "Most Recent",
  best: "Best Score",
  worst: "Lowest Score",
}
